import { AxiosResponse } from 'axios'
import { configAPI } from '../api'

export class ConfigService {
  static getConfig(fields: string[]): Promise<AxiosResponse<Record<string, unknown>>> {
    return configAPI.getConfigValuesUsingGET(fields) as Promise<AxiosResponse<Record<string, unknown>>>
  }
}
